var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import React from "react";
import { Container } from "react-bootstrap";
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.buttons = [];
        _this.pageEmpty = true;
        if (props.buttons !== undefined) {
            _this.buttons = props.buttons;
        }
        if (props.pageEmpty === undefined) {
            _this.pageEmpty = false;
        }
        return _this;
    }
    Header.prototype.render = function () {
        return (_jsxs("div", { children: [_jsx("div", __assign({ className: "header" }, { children: _jsx("header", __assign({ className: "masthead text-center text-white" }, { children: _jsxs("div", __assign({ className: "masthead-content" }, { children: [_jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsx("li", {}), _jsxs(Container, { children: [_jsx("div", { className: 'navbar-filler' }), _jsx("h1", __assign({ className: "masthead-heading mb-0" }, { children: this.props.title })), _jsx("h2", __assign({ className: "masthead-subheading mb-0" }, { children: this.props.subTitle })), this.buttons.map(function (button) { return (_jsx("a", __assign({ href: button.href, className: "btn btn-primary btn-xl rounded-pill mt-5" }, { children: button.text }), button.text)); })] })] })) })) })), this.pageEmpty ?
                    _jsx("h6", { children: "\u200E" })
                    :
                        _jsx(_Fragment, {})] }));
    };
    return Header;
}(React.Component));
export default Header;
